import { Injectable } from '@angular/core';
import { Guid } from 'guid-typescript';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders, HttpResponse, HttpParams } from '@angular/common/http';
import { PlugpointEnvironment } from '../PlugpointEnvironment';
import { ActivityLog } from './log';

@Injectable({
    providedIn: 'root'
})

export class LogService {
    url: string;
    constructor(
        public http: HttpClient

    ) {
        this.url = PlugpointEnvironment.url;

    }
    async getTriggerMsgLogs(): Promise<any> {
        let sessionId = Guid.create().toString();
        const today = new Date().getTime();
        const thirtyDaysAgo = today - 2592000000;
        const httpOptionsLocal = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', "SessionID": sessionId, 'Authorization': 'Basic Sjl1aFlzN1RxWjpOfVcxWFF2JDloRg==' })
        };
        let uri = this.url + `/events-logger/activity-log/all-by-fields?topic=trigger-message-all&from=${thirtyDaysAgo}&to=${today}`
        const response = await fetch(uri, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'SessionID': sessionId,
                'Authorization': 'Basic Sjl1aFlzN1RxWjpOfVcxWFF2JDloRg=='
            }
        })
        return await response.json();
    }

    getActivityLogs(
        from: number, to: number, page: number, size: number, sortBy: string, sortDirection: string): Observable<any> {
        let sessionId = Guid.create().toString();
        // Create query parameters with pagination and sorting values
        const params = new HttpParams()
            .set('from', from.toString())
            .set('to', to.toString())
            .set('page', page.toString())
            .set('size', size.toString())
            .set('sortBy', sortBy.toString()) // eg. 'sent'
            .set('sortDirection', sortDirection.toString()); // eg. 'asc ,desc'
        const httpOptionsLocal = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', "SessionID": sessionId, 'Authorization': 'Basic Sjl1aFlzN1RxWjpOfVcxWFF2JDloRg==' }),
            params: params
        };

        return this.http.get(`${this.url}/events-logger/activity-log/all-from-interval`, httpOptionsLocal);
    }
    getLogs(start: number, end: number): Observable<any> {
        let sessionId = Guid.create().toString();
        const httpOptionsLocal = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', "SessionID": sessionId, 'Authorization': 'Basic Sjl1aFlzN1RxWjpOfVcxWFF2JDloRg==' })
        };
        let uri = this.url + `/events-logger/activity-log/all-from-interval?from=${start}&to=${end}`
        return this.http.get<any>(uri, httpOptionsLocal);
    }
    addLog(log: ActivityLog) {
        let sessionId = Guid.create().toString();
        const httpOptionsLocal = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', "SessionID": sessionId })
        };
        let uri = this.url + `/events-logger/activity-log/add`
        let sent = new Date().getTime();
        let body = {
            "userId": log.userId,
            "sent": sent,
            "topic": log.topic,
            "action": log.action,
            "entity": log.entity,
            "oldData": log.oldData,
            "newData": log.newData,
            "additionalData": log.additionalData
        }

        // console.log('added log ' + JSON.stringify(body))
        // console.log('at uri ' + uri)
        //functioneaza doar cu .toPromise() ???? sunt foarte confuz
        return this.http.post(uri, body, httpOptionsLocal).toPromise();
    }
    getLogsByField(body: object): Observable<any> {
        let sessionId = Guid.create().toString();
        const httpOptionsLocal = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', "SessionID": sessionId, 'Authorization': 'Basic Sjl1aFlzN1RxWjpOfVcxWFF2JDloRg==' }),
        };
        console.log(body)
        let uri = this.url + `/events-logger/activity-log/all-by-fields?`
        for (let key in body) {
            if (body[key] != null) {
                uri += `${key}=${body[key]}&`
            }
        }
        uri = uri.substring(0, uri.length - 1);
        return this.http.get<any>(uri, httpOptionsLocal);

    }
    getEventsBySessionId(sessionId: string) {

        let session = Guid.create().toString();

        const httpOptionsLocal = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', "SessionID": session, 'Authorization': 'Basic Sjl1aFlzN1RxWjpOfVcxWFF2JDloRg==' }),
        };

        let uri = this.url + `/events-logger/session/${sessionId}`

        return this.http.get<any>(uri, httpOptionsLocal);
    }
    getEventsByUserId(userId: string, startDate: number, endDate: number) {

        let sessionId = Guid.create().toString();

        const httpOptionsLocal = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', "SessionID": sessionId, 'Authorization': 'Basic Sjl1aFlzN1RxWjpOfVcxWFF2JDloRg==' }),
        };

        let uri = this.url + `/events-logger/user-interval/${userId}/${startDate}/${endDate}`

        return this.http.get<any>(uri, httpOptionsLocal);
    }
    getEventsByEvseId(evseId: string, startDate: number, endDate: number) {

        let sessionId = Guid.create().toString();

        const httpOptionsLocal = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', "SessionID": sessionId, 'Authorization': 'Basic Sjl1aFlzN1RxWjpOfVcxWFF2JDloRg==' }),
        };

        let uri = this.url + `/events-logger/evse-interval/${evseId}/${startDate}/${endDate}`

        return this.http.get<any>(uri, httpOptionsLocal);
    }
    getEventsByMessage(message: string, startDate: number, endDate: number) {

        let sessionId = Guid.create().toString();

        const httpOptionsLocal = {
            headers: new HttpHeaders({ 'Content-Type': 'application/json', "SessionID": sessionId, 'Authorization': 'Basic Sjl1aFlzN1RxWjpOfVcxWFF2JDloRg==' }),
        };

        let uri = this.url + `/events-logger/message-interval/${message}/${startDate}/${endDate}`

        return this.http.get<event[]>(uri, httpOptionsLocal);
    }
}
export interface event {
    error: boolean,
    eventId : number,
    message: string,
    sessionId: string,
    timestamp: number,
    userId: string,
    service: string,
    additionalData: string,
    evseId: string,
}
